import { useState, useRef } from "react";
import { Text } from "@aidron/aidron-ds";
import PropTypes from 'prop-types';

export function ColumnLabelCell({ uiState }) {

  const {
    column,
    upperCellsHeight,
    linesSpan = "1",
    cellLeftBorder = false,
    cellBottomBorder = false,
    renderSortByButton,
    cellTopBorder = false,
  } = uiState || {};

  const [isHovered, setIsHovered] = useState(false);
  const textRef = useRef(null);
  const tooltipText = column.fullLabel;

  return (
    <th
      rowSpan={linesSpan}
      className={`subtitle-cell vertical-align-middle column-label-cell z-3
        ${cellLeftBorder ? "cell-left-border" : ""} 
        ${cellTopBorder ? "cell-top-border" : ""} 
        ${cellBottomBorder ? "cell-bottom-border" : ""} 
        ${column.type === "dif%" || column.type === "dif" ? "white-space-unset" : ""}`}
      style={{ top: `${upperCellsHeight}px` }}
    >
      <div className="d-flex justify-content-center">
        <div
          className={`d-flex align-items-center justify-content-center small-arrow-button table-text width-12px-on-icon height-12px-on-icon position-relative
          ${column.type === "dif%" || column.type === "dif" ? "width-105px" : ""}`}
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
        >
          <Text ref={textRef} className="text-center" >{column.label}</Text>
          {isHovered && tooltipText && <div className="column-label-tooltip">{tooltipText}</div>}
          {renderSortByButton}
        </div>
      </div>
    </th>
  );
}

ColumnLabelCell.propTypes = {
  uiState: PropTypes.shape()
}